module.exports = __webpack_public_path__ + "static/media/tennis-ball.34075655.svg";